import React, {useState, useEffect, useRef, useContext, Fragment} from "react";
import {useHistory, useParams} from 'react-router-dom'
import Card from "../../../components/Card";
import {Field, Form, Formik} from "formik"
import ModalMsg from "../../../components/ModalMsg";
import * as Yup from "yup";
import {LoaderContext} from "../../../context/LoaderContext";
import {TranslateContext} from "../../../context/TranslateContext";
import LabelErroreCampo from "../../../components/LabelErroreCampo";
import NsFormikScrollToError from "../../../components/NsFormikScrollToError";
import NsBtnBack from "../../../components/buttons/NsBtnBack";
import {
    aggiornaTitoloUtenteApi,
    aggiungiTitoloUtenteApi,
    getTitoloUtenteByIdApi
} from "../../../services/UtentiServices";

function ModificaTitolo() {
    const {id} = useParams()

    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {traduci} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getTitolo() {
        startChiamata();
        const response = await getTitoloUtenteByIdApi(id);
        let val = response.data.data;
        setLoadingData(false);

        if (formikRef.current) {
            formikRef.current.setFieldValue("id_titolo", val.id_titolo);
            formikRef.current.setFieldValue("tipo", val.tipo);
        }
        endChiamata();
    }

    useEffect(() => {
        if (loadingData) {
            if (id && id !== '') {
                getTitolo();
            }
        }
    }, [id]);

    const SignupSchema = Yup.object().shape({
        id_titolo: Yup.string()
            .max(20, traduci('Attenzione! Hai inserito troppi caratteri'))
            .required(traduci('Questo campo è obbligatorio')),
        tipo: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
    });

    const closeModal = () => setShow(false);

    async function aggiornaTitoloUtente(values) {
        startChiamata();
        const response = await aggiornaTitoloUtenteApi(id, values);
        endChiamata();
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiTitoloUtente(values) {
        startChiamata();
        const response = await aggiungiTitoloUtenteApi(values);
        endChiamata();
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    return (
        <Card
            icon={'fas fa-tag'}
            title={id ? 'Modifica Titolo' : 'Inserisci Titolo'}
            getBottoniDx={() =>
                <Fragment>
                    <NsBtnBack/>
                    <button type="button" id="salva" name="salva"
                            className="btn btn-card"
                            onClick={() => {
                                if (formikRef.current) {
                                    formikRef.current.handleSubmit()
                                }
                            }}>
                        <i className="fas fa-save"/> Salva
                    </button>
                </Fragment>
            }
        >
            <ModalMsg
                show={show}
                handleClose={closeModal}
                testo={modalMsg}/>
            <Formik
                initialValues={{
                    id_titolo: '',
                    tipo: '1'
                }}
                innerRef={formikRef}
                validationSchema={SignupSchema}
                onSubmit={values => {
                    if (id) {
                        aggiornaTitoloUtente(values);
                    } else {
                        aggiungiTitoloUtente(values);
                    }
                }}
            >
                {({errors, touched, submitCount, values}) => (
                    <Form className="row g-3">
                        <div className="col-md-12">
                            <label htmlFor="id_titolo" className="form-label">Titolo*:</label>
                            <Field
                                name="id_titolo"
                                className="form-control"
                                readOnly={id}
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"id_titolo"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="tipo" className="form-label">Tipo*:</label>
                            <Field
                                as={"select"}
                                name="tipo"
                                className="form-control form-select"
                                value={values['tipo']}
                                onChange={(event) => {
                                    formikRef.current.setFieldValue("tipo", event.target.value)
                                }}
                            >
                                <option value={''}></option>
                                <option value={'1'}>Titolo 1</option>
                                <option value={'2'}>Titolo 2</option>
                            </Field>
                            <LabelErroreCampo errors={errors} touched={touched} name={"tipo"}
                                              submitCount={submitCount}/>
                        </div>

                        <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                    </Form>
                )}
            </Formik>
        </Card>
    );
}

export default ModificaTitolo;